// // import { useState } from "react";

// // const Inputfield = ({
// //   type = "text", // "text", "dropdown", "radio"
// //   name,
// //   placeholder = "",
// //   required = false,
// //   label = null,
// //   options = [], // Array of strings or objects [{ value: "", label: "" }]
// //   selectedValues,
// //   setSelectedValues
// // }) => {
// //   const handleCheckboxChange = (e) => {
// //     const { value, checked } = e.target;
// //     const existingEntry = selectedValues.find((entry) => entry.label === label) || {
// //       label,
// //       values: [],
// //     };
// //     const updatedValues = checked
// //       ? [...existingEntry.values, value]
// //       : existingEntry.values.filter((item) => item !== value);
// //     const updatedEntry = { label, values: updatedValues };
// //     const otherEntries = selectedValues.filter((entry) => entry.label !== label);
// //     setSelectedValues([...otherEntries, updatedEntry].filter((entry) => entry.values.length > 0));
// //   };

// //   const handleTextChange = (e) => {
// //     const value = e.target.value;
// //     const existingEntry = selectedValues.find((entry) => entry.label === label) || {
// //       label,
// //       values: [],
// //     };
// //     const updatedEntry = { label, values: value ? [value] : [] };
// //     const otherEntries = selectedValues.filter((entry) => entry.label !== label);
// //     setSelectedValues([...otherEntries, updatedEntry].filter((entry) => entry.values.length > 0));
// //   };

// //   const handleRadioChange = (e) => {
// //     const value = e.target.value;
// //     const existingEntry = selectedValues.find((entry) => entry.label === label) || {
// //       label,
// //       values: [],
// //     };
// //     const updatedEntry = { label, values: [value] };
// //     const otherEntries = selectedValues.filter((entry) => entry.label !== label);
// //     setSelectedValues([...otherEntries, updatedEntry]);
// //   };

// //   if (type === "dropdown") {
// //     return (
// //       <div className="p-4 bg-white rounded-lg shadow-md border border-gray-300 max-w-md mx-auto">
// //         <h2 className="text-lg font-bold mb-4 text-gray-800">{label}</h2>
// //         {options.map((item) => {
// //           const value = typeof item === "object" ? item.value : item;
// //           const display = typeof item === "object" ? item.label : item;
// //           return (
// //             <label
// //               key={value}
// //               className="flex items-center mb-2 cursor-pointer text-gray-700 hover:text-blue-600"
// //             >
// //               <input
// //                 type="checkbox"
// //                 value={value}
// //                 onChange={handleCheckboxChange}
// //                 checked={
// //                   selectedValues
// //                     .find((entry) => entry.label === label)
// //                     ?.values.includes(value) || false
// //                 }
// //                 className="mr-3 w-5 h-5 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
// //                 required={required}
// //               />
// //               {display}
// //             </label>
// //           );
// //         })}
// //         <div className="mt-6">
// //           <span className="block text-sm font-semibold text-gray-700 mb-2">Selected:</span>
// //           {selectedValues.find((entry) => entry.label === label)?.values.length > 0 ? (
// //             <div className="flex flex-wrap gap-2">
// //               {selectedValues
// //                 .find((entry) => entry.label === label)
// //                 ?.values.map((val) => {
// //                   const option = options.find(
// //                     (opt) => (typeof opt === "object" ? opt.value : opt) === val
// //                   );
// //                   const display = option && typeof option === "object" ? option.label : val;
// //                   return (
// //                     <span
// //                       key={val}
// //                       className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-medium"
// //                     >
// //                       {display}
// //                     </span>
// //                   );
// //                 })}
// //             </div>
// //           ) : (
// //             <p className="text-gray-500 text-sm italic">None</p>
// //           )}
// //         </div>
// //       </div>
// //     );
// //   }

// //   if (type === "text") {
// //     return (
// //       <div className="max-w-md mx-auto p-4 bg-white rounded shadow">
// //         <h2 className="text-lg font-bold mb-4 text-gray-800">{label}</h2>
// //         <input
// //           type="text"
// //           value={
// //             selectedValues.find((entry) => entry.label === label)?.values[0] || ""
// //           }
// //           onChange={handleTextChange}
// //           className="border border-gray-300 rounded p-2 w-full"
// //           placeholder={placeholder}
// //           required={required}
// //           name={name}
// //         />
// //         <div className="mt-6">
// //           <span className="block text-sm font-semibold text-gray-700 mb-2">Selected:</span>
// //           {selectedValues.find((entry) => entry.label === label)?.values.length > 0 ? (
// //             <div className="flex flex-wrap gap-2">
// //               {selectedValues
// //                 .find((entry) => entry.label === label)
// //                 ?.values.map((val) => (
// //                   <span
// //                     key={val}
// //                     className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-medium"
// //                   >
// //                     {val}
// //                   </span>
// //                 ))}
// //             </div>
// //           ) : (
// //             <p className="text-gray-500 text-sm italic">None</p>
// //           )}
// //         </div>
// //       </div>
// //     );
// //   }

// //   if (type === "radio") {
// //     return (
// //       <div className="p-4 bg-white rounded-lg shadow-md border border-gray-300 max-w-md mx-auto">
// //         <h2 className="text-lg font-bold mb-4 text-gray-800">{label}</h2>
// //         {options.map((item) => {
// //           const value = typeof item === "object" ? item.value : item;
// //           const display = typeof item === "object" ? item.label : item;
// //           return (
// //             <label
// //               key={value}
// //               className="flex items-center mb-2 cursor-pointer text-gray-700 hover:text-blue-600"
// //             >
// //               <input
// //                 type="radio"
// //                 name={name}
// //                 value={value}
// //                 checked={
// //                   selectedValues
// //                     .find((entry) => entry.label === label)
// //                     ?.values.includes(value) || false
// //                 }
// //                 onChange={handleRadioChange}
// //                 className="mr-3 w-5 h-5 text-blue-600 focus:ring-blue-500"
// //                 required={required}
// //               />
// //               {display}
// //             </label>
// //           );
// //         })}
// //         <div className="mt-4">
// //           <span className="block text-sm font-semibold text-gray-700 mb-1">Selected:</span>
// //           {selectedValues.find((entry) => entry.label === label)?.values.length > 0 ? (
// //             <div className="flex flex-wrap gap-2">
// //               {selectedValues
// //                 .find((entry) => entry.label === label)
// //                 ?.values.map((val) => {
// //                   const option = options.find(
// //                     (opt) => (typeof opt === "object" ? opt.value : opt) === val
// //                   );
// //                   const display = option && typeof option === "object" ? option.label : val;
// //                   return (
// //                     <span
// //                       key={val}
// //                       className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-medium"
// //                     >
// //                       {display}
// //                     </span>
// //                   );
// //                 })}
// //             </div>
// //           ) : (
// //             <p className="text-gray-500 text-sm italic">None</p>
// //           )}
// //         </div>
// //       </div>
// //     );
// //   }

// //   return null;
// // };

// // export default Inputfield;
// import { useState } from "react";

// const Inputfield = ({
//   type = "text", // "text", "dropdown", "radio"
//   name,
//   placeholder = "",
//   required = false,
//   label = null,
//   options = [], // Array of strings or objects [{ value: "", label: "" }]
//   selectedValues,
//   setSelectedValues
// }) => {
//   const handleCheckboxChange = (e) => {
//     const { value, checked } = e.target;
//     const existingEntry = selectedValues.find((entry) => entry.label === label) || {
//       label,
//       values: [],
//     };
//     const updatedValues = checked
//       ? [...existingEntry.values, value]
//       : existingEntry.values.filter((item) => item !== value);
//     const updatedEntry = { label, values: updatedValues };
//     const otherEntries = selectedValues.filter((entry) => entry.label !== label);
//     setSelectedValues([...otherEntries, updatedEntry].filter((entry) => entry.values.length > 0));
//   };

//   const handleTextChange = (e) => {
//     const value = e.target.value;
//     const existingEntry = selectedValues.find((entry) => entry.label === label) || {
//       label,
//       values: [],
//     };
//     const updatedEntry = { label, values: value ? [value] : [] };
//     const otherEntries = selectedValues.filter((entry) => entry.label !== label);
//     setSelectedValues([...otherEntries, updatedEntry].filter((entry) => entry.values.length > 0));
//   };

//   const handleRadioChange = (e) => {
//     const value = e.target.value;
//     const existingEntry = selectedValues.find((entry) => entry.label === label) || {
//       label,
//       values: [],
//     };
//     const updatedEntry = { label, values: [value] };
//     const otherEntries = selectedValues.filter((entry) => entry.label !== label);
//     setSelectedValues([...otherEntries, updatedEntry]);
//   };

//   if (type === "dropdown") {
//     return (
//       <div className="p-6 bg-gradient-to-br from-white to-gray-50 rounded-xl shadow-lg border border-gray-200 max-w-lg mx-auto transition-all duration-300 hover:shadow-xl">
//         <h2 className="text-xl font-semibold text-gray-900 mb-5 tracking-tight hover:underline decoration-blue-500 decoration-2">
//           {label}
//         </h2>
//         {options.map((item) => {
//           const value = typeof item === "object" ? item.value : item;
//           const display = typeof item === "object" ? item.label : item;
//           return (
//             <label
//               key={value}
//               className="flex items-center mb-3 cursor-pointer text-gray-700 hover:text-blue-600 transition-colors duration-200"
//             >
//               <input
//                 type="checkbox"
//                 value={value}
//                 onChange={handleCheckboxChange}
//                 checked={
//                   selectedValues
//                     .find((entry) => entry.label === label)
//                     ?.values.includes(value) || false
//                 }
//                 className="mr-3 w-5 h-5 text-blue-600 rounded border-gray-300 focus:ring-2 focus:ring-blue-400 focus:ring-offset-2 transition-colors duration-200"
//                 required={required}
//               />
//               <span className="text-base font-medium">{display}</span>
//             </label>
//           );
//         })}
//         <div className="mt-6">
//           <span className="block text-sm font-semibold text-gray-800 mb-3 tracking-wide">
//             Selected:
//           </span>
//           {selectedValues.find((entry) => entry.label === label)?.values.length > 0 ? (
//             <div className="flex flex-wrap gap-2">
//               {selectedValues
//                 .find((entry) => entry.label === label)
//                 ?.values.map((val) => {
//                   const option = options.find(
//                     (opt) => (typeof opt === "object" ? opt.value : opt) === val
//                   );
//                   const display = option && typeof option === "object" ? option.label : val;
//                   return (
//                     <span
//                       key={val}
//                       className="bg-blue-100 text-blue-800 px-4 py-1.5 rounded-full text-sm font-medium hover:bg-blue-200 hover:scale-105 transition-all duration-200"
//                     >
//                       {display}
//                     </span>
//                   );
//                 })}
//             </div>
//           ) : (
//             <p className="text-gray-400 text-sm italic">No selections</p>
//           )}
//         </div>
//       </div>
//     );
//   }

//   if (type === "text") {
//     return (
//       <div className="p-6 bg-gradient-to-br from-white to-gray-50 rounded-xl shadow-lg border border-gray-200 max-w-lg mx-auto transition-all duration-300 hover:shadow-xl">
//         <h2 className="text-xl font-semibold text-gray-900 mb-5 tracking-tight hover:underline decoration-blue-500 decoration-2">
//           {label}
//         </h2>
//         <input
//           type="text"
//           value={
//             selectedValues.find((entry) => entry.label === label)?.values[0] || ""
//           }
//           onChange={handleTextChange}
//           className="border border-gray-300 rounded-lg p-3 w-full text-base text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-500 transition-all duration-200 placeholder-gray-400"
//           placeholder={placeholder}
//           required={required}
//           name={name}
//         />
//         <div className="mt-6">
//           <span className="block text-sm font-semibold text-gray-800 mb-3 tracking-wide">
//             Selected:
//           </span>
//           {selectedValues.find((entry) => entry.label === label)?.values.length > 0 ? (
//             <div className="flex flex-wrap gap-2">
//               {selectedValues
//                 .find((entry) => entry.label === label)
//                 ?.values.map((val) => (
//                   <span
//                     key={val}
//                     className="bg-blue-100 text-blue-800 px-4 py-1.5 rounded-full text-sm font-medium hover:bg-blue-200 hover:scale-105 transition-all duration-200"
//                   >
//                     {val}
//                   </span>
//                 ))}
//             </div>
//           ) : (
//             <p className="text-gray-400 text-sm italic">No selections</p>
//           )}
//         </div>
//       </div>
//     );
//   }

//   if (type === "radio") {
//     return (
//       <div className="p-6 bg-gradient-to-br from-white to-gray-50 rounded-xl shadow-lg border border-gray-200 max-w-lg mx-auto transition-all duration-300 hover:shadow-xl">
//         <h2 className="text-xl font-semibold text-gray-900 mb-5 tracking-tight hover:underline decoration-blue-500 decoration-2">
//           {label}
//         </h2>
//         {options.map((item) => {
//           const value = typeof item === "object" ? item.value : item;
//           const display = typeof item === "object" ? item.label : item;
//           return (
//             <label
//               key={value}
//               className="flex items-center mb-3 cursor-pointer text-gray-700 hover:text-blue-600 transition-colors duration-200"
//             >
//               <input
//                 type="radio"
//                 name={name}
//                 value={value}
//                 checked={
//                   selectedValues
//                     .find((entry) => entry.label === label)
//                     ?.values.includes(value) || false
//                 }
//                 onChange={handleRadioChange}
//                 className="mr-3 w-5 h-5 text-blue-600 focus:ring-2 focus:ring-blue-400 focus:ring-offset-2 transition-colors duration-200"
//                 required={required}
//               />
//               <span className="text-base font-medium">{display}</span>
//             </label>
//           );
//         })}
//         <div className="mt-6">
//           <span className="block text-sm font-semibold text-gray-800 mb-3 tracking-wide">
//             Selected:
//           </span>
//           {selectedValues.find((entry) => entry.label === label)?.values.length > 0 ? (
//             <div className="flex flex-wrap gap-2">
//               {selectedValues
//                 .find((entry) => entry.label === label)
//                 ?.values.map((val) => {
//                   const option = options.find(
//                     (opt) => (typeof opt === "object" ? opt.value : opt) === val
//                   );
//                   const display = option && typeof option === "object" ? option.label : val;
//                   return (
//                     <span
//                       key={val}
//                       className="bg-blue-100 text-blue-800 px-4 py-1.5 rounded-full text-sm font-medium hover:bg-blue-200 hover:scale-105 transition-all duration-200"
//                     >
//                       {display}
//                     </span>
//                   );
//                 })}
//             </div>
//           ) : (
//             <p className="text-gray-400 text-sm italic">No selections</p>
//           )}
//         </div>
//       </div>
//     );
//   }

//   return null;
// };

// export default Inputfield;
import { useState } from "react";
import { FaPlus, FaTimes } from "react-icons/fa";

const Inputfield = ({
  type = "text", // "text", "dropdown", "radio"
  name,
  placeholder = "",
  required = false,
  label = null,
  options = [], // Array of strings or objects [{ value: "", label: "" }]
  selectedValues,
  setSelectedValues,
  Attribute_Category,
  ID,
  Parent_Variant_Id,
  Attribute_Type,
  ide
}) => {
  const [showTextInput, setShowTextInput] = useState(false);
  const [newOption, setNewOption] = useState("");

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    const existingEntry = selectedValues.find((entry) => entry.label === label) || {
      label,
      values: [],
    };
    const updatedValues = checked
      ? [...existingEntry.values, value]
      : existingEntry.values.filter((item) => item !== value);
    const updatedEntry = { label, values: updatedValues,Attribute_Category, ID ,Parent_Variant_Id,Attribute_Type,ide};
    const otherEntries = selectedValues.filter((entry) => entry.label !== label);
    setSelectedValues([...otherEntries, updatedEntry].filter((entry) => entry.values.length > 0));
  };

  const handleTextChange = (e) => {
    const value = e.target.value;
    const existingEntry = selectedValues.find((entry) => entry.label === label) || {
      label,
      values: [],
    };
    const updatedEntry = { label, values: value ? [value] : [],Attribute_Category,ID ,Parent_Variant_Id,Attribute_Type,ide};
    const otherEntries = selectedValues.filter((entry) => entry.label !== label);
    setSelectedValues([...otherEntries, updatedEntry].filter((entry) => entry.values.length > 0));
  };

  const handleRadioChange = (e) => {
    const value = e.target.value;
    const existingEntry = selectedValues.find((entry) => entry.label === label) || {
      label,
      values: [],
    };
    const updatedEntry = { label, values: [value],Attribute_Category, ID ,Parent_Variant_Id,Attribute_Type,ide};
    const otherEntries = selectedValues.filter((entry) => entry.label !== label);
    setSelectedValues([...otherEntries, updatedEntry]);
  };

  const handleNewOptionChange = (e) => {
    setNewOption(e.target.value);
  };

  const addNewOption = () => {
    if (newOption.trim() && !selectedValues.find((entry) => entry.label === label)?.values.includes(newOption)) {
      const existingEntry = selectedValues.find((entry) => entry.label === label) || {
        label,
        values: [],
      };
      const updatedEntry = { label, values: [...existingEntry.values, newOption], custom: true,Attribute_Category,ID,Parent_Variant_Id ,Attribute_Type,ide};
      const otherEntries = selectedValues.filter((entry) => entry.label !== label);
      setSelectedValues([...otherEntries, updatedEntry]);
      setNewOption("");
      setShowTextInput(false);
    }
  };

  const removeCustomOption = (valueToRemove) => {
    const existingEntry = selectedValues.find((entry) => entry.label === label) || {
      label,
      values: [],
    };
    const updatedValues = existingEntry.values.filter((value) => value !== valueToRemove);
    const updatedEntry = { label, values: updatedValues, custom: existingEntry.custom, Attribute_Category: existingEntry.Attribute_Category||Attribute_Category, ID: existingEntry.ID||ID, Parent_Variant_Id:existingEntry.Parent_Variant_Id||Parent_Variant_Id, Attribute_Type:existingEntry.Attribute_Type||Attribute_Type,ide:existingEntry.ide||ide };
    const otherEntries = selectedValues.filter((entry) => entry.label !== label);
    setSelectedValues([...otherEntries, updatedEntry].filter((entry) => entry.values.length > 0));
  };

  if (type === "dropdown") {
  return (
    <div className="p-6 bg-gradient-to-br from-white to-gray-50 rounded-xl shadow-lg border border-gray-200 max-w-lg mx-auto transition-all duration-300 hover:shadow-xl">
      <h2 className="text-xl font-semibold text-gray-900 mb-5 tracking-tight hover:underline decoration-blue-500 decoration-2">
        {label}
      </h2>
      {options.map((item) => {
        const value = typeof item === "object" ? item.value : item;
        const display = typeof item === "object" ? item.label : item;
        return (
          <label
            key={value}
            className="flex items-center mb-3 cursor-pointer text-gray-700 hover:text-blue-600 transition-colors duration-200"
          >
            <input
              type="checkbox"
              value={value}
              onChange={handleCheckboxChange}
              checked={
                selectedValues
                  .find((entry) => entry.label === label)
                  ?.values.includes(value) || false
              }
              className="mr-3 w-5 h-5 text-blue-600 rounded border-gray-300 focus:ring-2 focus:ring-blue-400 focus:ring-offset-2 transition-colors duration-200"
              required={required}
            />
            <span className="text-base font-medium">{display}</span>
          </label>
        );
      })}
      <div className="mt-4 flex items-center">
        <button
          type="button"
          onClick={() => setShowTextInput(!showTextInput)}
          className="flex items-center justify-center w-8 h-8 bg-blue-600 text-white rounded-full hover:bg-blue-700 transition-colors duration-200"
        >
          <FaPlus size={16} />
        </button>
        {showTextInput && (
          <div className="ml-3 flex-1">
            <input
              type="text"
              value={newOption}
              onChange={handleNewOptionChange}
              onKeyPress={(e) => e.key === "Enter" && addNewOption()}
              placeholder="Type new option"
              className="border border-gray-300 rounded-lg p-2 w-full text-base text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-500 transition-all duration-200"
            />
            <button
              type="button"
              onClick={addNewOption}
              className="ml-2 px-3 py-1 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors duration-200"
            >
              Add
            </button>
          </div>
        )}
      </div>
      <div className="mt-6">
        <span className="block text-sm font-semibold text-gray-800 mb-3 tracking-wide">
          Selected:
        </span>
        {selectedValues.find((entry) => entry.label === label)?.values.length > 0 ? (
          <div className="flex flex-wrap gap-2">
            {selectedValues
              .find((entry) => entry.label === label)
              ?.values.map((val) => {
                const option = options.find(
                  (opt) => (typeof opt === "object" ? opt.value : opt) === val
                );
                const display = option && typeof option === "object" ? option.label : val;
                const isCustom = !options.some(
                  (opt) => (typeof opt === "object" ? opt.value : opt) === val
                );
                return (
                  <div
                    key={val}
                    className="flex items-center bg-blue-100 text-blue-800 px-4 py-1.5 rounded-full text-sm font-medium hover:bg-blue-200 hover:scale-105 transition-all duration-200"
                  >
                    <span>{display}</span>
                    {isCustom && (
                      <button
                        type="button"
                        onClick={() => removeCustomOption(val)}
                        className="ml-2 text-red-600 hover:text-red-800"
                      >
                        <FaTimes size={12} />
                      </button>
                    )}
                  </div>
                );
              })}
          </div>
        ) : (
          <p className="text-gray-400 text-sm italic">No selections</p>
        )}
      </div>
    </div>
  );
}

  if (type === "radio") {
    return (
      <div className="p-6 bg-gradient-to-br from-white to-gray-50 rounded-xl shadow-lg border border-gray-200 max-w-lg mx-auto transition-all duration-300 hover:shadow-xl">
        <h2 className="text-xl font-semibold text-gray-900 mb-5 tracking-tight hover:underline decoration-blue-500 decoration-2">
          {label}
        </h2>
        {options.map((item) => {
          const value = typeof item === "object" ? item.value : item;
          const display = typeof item === "object" ? item.label : item;
          return (
            <label
              key={value}
              className="flex items-center mb-3 cursor-pointer text-gray-700 hover:text-blue-600 transition-colors duration-200"
            >
              <input
                type="radio"
                name={name}
                value={value}
                checked={
                  selectedValues
                    .find((entry) => entry.label === label)
                    ?.values.includes(value) || false
                }
                onChange={handleRadioChange}
                className="mr-3 w-5 h-5 text-blue-600 focus:ring-2 focus:ring-blue-400 focus:ring-offset-2 transition-colors duration-200"
                required={required}
              />
              <span className="text-base font-medium">{display}</span>
            </label>
          );
        })}
        
      </div>
    );
  }
  if (type === "text") {
  return (
    <div className="p-6 bg-gradient-to-br from-white to-gray-50 rounded-xl shadow-lg border border-gray-200 max-w-lg mx-auto transition-all duration-300 hover:shadow-xl">
      <h2 className="text-xl font-semibold text-gray-900 mb-5 tracking-tight hover:underline decoration-blue-500 decoration-2">
        {label}
      </h2>
      <input
        type="text"
        placeholder={placeholder}
        required={required}
        onChange={handleTextChange}
        value={
          selectedValues.find((entry) => entry.label === label)?.values[0] || ""
        }
        className="border border-gray-300 rounded-lg p-2 w-full text-base text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-500 transition-all duration-200"
      />
    </div>
  );
}
  if (type === "checkbox") {
  return (
    <div className="p-6 bg-gradient-to-br from-white to-gray-50 rounded-xl shadow-lg border border-gray-200 max-w-lg mx-auto transition-all duration-300 hover:shadow-xl">
      <h2 className="text-xl font-semibold text-gray-900 mb-5 tracking-tight hover:underline decoration-blue-500 decoration-2">
        {label}
      </h2>
      {options.map((item) => {
        const value = typeof item === "object" ? item.value : item;
        const display = typeof item === "object" ? item.label : item;
        return (
          <label
            key={value}
            className="flex items-center mb-3 cursor-pointer text-gray-700 hover:text-blue-600 transition-colors duration-200"
          >
            <input
              type="checkbox"
              value={value}
              onChange={handleCheckboxChange}
              checked={
                selectedValues
                  .find((entry) => entry.label === label)
                  ?.values.includes(value) || false
              }
              className="mr-3 w-5 h-5 text-blue-600 rounded border-gray-300 focus:ring-2 focus:ring-blue-400 focus:ring-offset-2 transition-colors duration-200"
              required={required}
            />
            <span className="text-base font-medium">{display}</span>
          </label>
        );
      })}
      <div className="mt-4 flex items-center">
        <button
          type="button"
          onClick={() => setShowTextInput(!showTextInput)}
          className="flex items-center justify-center w-8 h-8 bg-blue-600 text-white rounded-full hover:bg-blue-700 transition-colors duration-200"
        >
          <FaPlus size={16} />
        </button>
        {showTextInput && (
          <div className="ml-3 flex-1">
            <input
              type="text"
              value={newOption}
              onChange={handleNewOptionChange}
              onKeyPress={(e) => e.key === "Enter" && addNewOption()}
              placeholder="Type new option"
              className="border border-gray-300 rounded-lg p-2 w-full text-base text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-500 transition-all duration-200"
            />
            <button
              type="button"
              onClick={addNewOption}
              className="ml-2 px-3 py-1 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors duration-200"
            >
              Add
            </button>
          </div>
        )}
      </div>
      <div className="mt-6">
        <span className="block text-sm font-semibold text-gray-800 mb-3 tracking-wide">
          Selected:
        </span>
        {selectedValues.find((entry) => entry.label === label)?.values.length > 0 ? (
          <div className="flex flex-wrap gap-2">
            {selectedValues
              .find((entry) => entry.label === label)
              ?.values.map((val) => {
                const option = options.find(
                  (opt) => (typeof opt === "object" ? opt.value : opt) === val
                );
                const display = option && typeof option === "object" ? option.label : val;
                const isCustom = !options.some(
                  (opt) => (typeof opt === "object" ? opt.value : opt) === val
                );
                return (
                  <div
                    key={val}
                    className="flex items-center bg-blue-100 text-blue-800 px-4 py-1.5 rounded-full text-sm font-medium hover:bg-blue-200 hover:scale-105 transition-all duration-200"
                  >
                    <span>{display}</span>
                    {isCustom && (
                      <button
                        type="button"
                        onClick={() => removeCustomOption(val)}
                        className="ml-2 text-red-600 hover:text-red-800"
                      >
                        <FaTimes size={12} />
                      </button>
                    )}
                  </div>
                );
              })}
          </div>
        ) : (
          <p className="text-gray-400 text-sm italic">No selections</p>
        )}
      </div>
    </div>
  );
}
  return null;
};

export default Inputfield;